import React from 'react';

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var CuratedInternalIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32"
  }, props), React.createElement("g", {
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: "none",
    d: "M0 0h32v32H0z"
  }), React.createElement("path", {
    fillRule: "nonzero",
    d: "M4 4v24h24V4H4zM2 2h28v28H2V2z"
  }), React.createElement("path", {
    fillRule: "nonzero",
    d: "M10.5 15.826c0-1.189.291-2.278.873-3.244a6.137 6.137 0 0 1 2.356-2.273 6.68 6.68 0 0 1 3.24-.809c.945 0 1.841.191 2.677.574.824.385 1.54.924 2.144 1.615l.331.38-2.142 1.847-.328-.367a3.634 3.634 0 0 0-1.195-.896 3.507 3.507 0 0 0-1.488-.315c-.995 0-1.806.327-2.456.987-.66.67-.985 1.488-.985 2.501 0 1.014.324 1.83.984 2.488.652.66 1.465.987 2.457.987.538 0 1.041-.109 1.513-.325a3.37 3.37 0 0 0 1.193-.901l.327-.39 2.128 1.849-.316.376a6.207 6.207 0 0 1-2.15 1.644 6.292 6.292 0 0 1-2.695.59 6.705 6.705 0 0 1-2.51-.476 6.337 6.337 0 0 1-2.061-1.31 6.16 6.16 0 0 1-1.386-2.014 6.215 6.215 0 0 1-.511-2.518z"
  })));
});

export default CuratedInternalIcon;
//# sourceMappingURL=curated-internal.svg.js.map
